import { camelCaseToTitleCase } from "../../../utils/stringManipulation";

const formatToolName = (name?: string | null) =>
  name ? camelCaseToTitleCase(name) : "Tool";

export const getToolCallStatus = (
  eventType: string | undefined,
  payload: Record<string, any>
): string | undefined => {
  if (!eventType) {
    return undefined;
  }

  switch (eventType) {
    case "function_call_started": {
      const toolName = formatToolName(payload?.name);
      return `Preparing ${toolName}...`;
    }
    case "executing_functions": {
      const count = Number(payload?.count ?? 0);
      if (!Number.isFinite(count) || count <= 0) {
        return undefined;
      }
      return count === 1
        ? "Executing 1 tool..."
        : `Executing ${count} tools...`;
    }
    case "function_execution_started": {
      const functionName = formatToolName(payload?.functionName);
      return `Running ${functionName}...`;
    }
    case "function_call_completed": {
      const callName = formatToolName(
        payload?.name ?? payload?.toolCall?.name
      );
      return `${callName} call complete.`;
    }
    case "function_executed": {
      const functionName = formatToolName(payload?.functionName);
      return `${functionName} finished.`;
    }
    case "function_error": {
      const functionName = formatToolName(payload?.functionName);
      const errorMessage =
        typeof payload?.error === "string" && payload.error.length > 0
          ? payload.error
          : undefined;
      return errorMessage
        ? `${functionName} failed: ${errorMessage}`
        : `${functionName} failed.`;
    }
    default:
      return undefined;
  }
};
